var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
import { headerButtonView } from '../../../HeaderButtons/buttonsView';
import { Colors, helperButtonReset, helperTypographyText } from '@utex/ui-kit';
export function getButtonColor(view) {
    switch (view) {
        case 'white':
            return headerButtonView['white-dim'];
        case 'black':
            return headerButtonView['black-dim'];
        default:
            return 'primary-dim';
    }
}
export var Container = styled('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-right: 2.4rem;\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  margin-right: 2.4rem;\n"])));
export var BalanceButton = styled('button')(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  z-index: 10;\n  margin-right: 1rem;\n  color: ", ";\n  transition: color 0.3s, opacity 0.3s;\n  cursor: ", ";\n\n  &:hover {\n    opacity: ", ";\n  }\n"], ["\n  ", ";\n  ",
    ";\n  z-index: 10;\n  margin-right: 1rem;\n  color: ",
    ";\n  transition: color 0.3s, opacity 0.3s;\n  cursor: ", ";\n\n  &:hover {\n    opacity: ", ";\n  }\n"])), helperButtonReset, helperTypographyText({
    size: 'M',
    lh: 'M',
}), function (props) {
    return props.view === 'white' && props.isTooltipOpen ? Colors.text.default : 'inherit';
}, function (props) { return (props.isTooltipOpen ? 'default' : 'pointer'); }, function (props) { return !props.isTooltipOpen && 0.5; });
var templateObject_1, templateObject_2;
//# sourceMappingURL=styles.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/dist/components/UserBlock/components/Balance/styles.js
// module id = 1366
// module chunks = 118